@if (inviteInfo) {
  <div class="dialog-info dialog-info-primary">
    <div class="row flex-nowrap">
      <div class="col-auto align-self-center">
        <span class="icon" [inlineSVG]="'/icons/icon-warning.svg'"></span>
      </div>
      <div class="col copy">
        {{ 'company.invite_login_info' | transloco }}
      </div>
    </div>
  </div>
}
<div class="dialog-panel">
  <div class="dialog-content">
    @if (loading) {
      <div class="spinner-container p-absolute">
        <mat-spinner class="primary" [diameter]="30"></mat-spinner>
      </div>
    }
    <form [ngClass]="{ 'v-hidden': loading }" [formGroup]="form" (submit)="onSubmit()">
      <div class="dialog-header">
        <h1 class="dialog-title dot">{{ 'global.signin' | transloco }}</h1>
      </div>
      <div class="dialog-body">
        @if (withFacebook) {
          <div class="auth-other-actions">
            <button type="button" class="btn btn-fb d-block w-100" (click)="facebookRedirect()">
              <span class="icon-fb" [inlineSVG]="'/icons/icon-fb.svg'"></span>
              {{ 'auth.signin_with_facebook' | transloco }}
            </button>
            <div class="d-block or">
              {{ 'global.or' | transloco }}
            </div>
          </div>
        }
        <div class="form-field-container">
          <div class="form-field-label">
            {{ 'form.field.email' | transloco }}
          </div>
          <mat-form-field class="form-field" [floatLabel]="'auto'">
            <input matInput formControlName="email" required />
            @if (getFormControl('email').invalid) {
              <mat-error>
                @if (getFormControl('email').errors.required) {
                  {{ 'form.error.required' | transloco }}
                }
                @if (getFormControl('email').errors.email) {
                  {{ 'form.error.invalid_email' | transloco }}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="form-field-container">
          <div class="form-field-label">
            {{ 'form.field.password' | transloco }}
          </div>
          <mat-form-field class="form-field form-field-password" [floatLabel]="'auto'">
            <input
              #passwordInput
              matInput
              [type]="hidePwd ? 'password' : 'text'"
              formControlName="password"
              required
              autocomplete="off"
              autocapitalize="none"
              autocorrect="off"
            />
            <span
              class="form-field-icon"
              [ngClass]="{ active: !hidePwd }"
              [inlineSVG]="'/icons/icon-eye.svg'"
              (click)="hidePwd = !hidePwd; $event.preventDefault()"
            ></span>
            @if (getFormControl('password').invalid) {
              <mat-error>
                @if (getFormControl('password').errors.required) {
                  {{ 'form.error.required' | transloco }}
                }
                @if (getFormControl('password').errors.incorrect_email_password) {
                  {{ 'form.error.incorrect_email_password' | transloco }}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="auth-other-actions">
          <button type="button" class="btn btn-forgot" (click)="handlePwdResetClicked($event)">
            {{ 'auth.forgot_password' | transloco }}
          </button>

          @if (signUpCustomHtmlCode) {
            <div [innerHTML]="signUpCustomHtmlCode"></div>
          } @else if (withSignUp) {
            <button type="button" class="btn btn-text" (click)="handleSignUpClicked($event)">
              {{ 'auth.dont_have_account' | transloco }}
              <span>
                {{ 'auth.signup_here' | transloco }}
              </span>
            </button>
          }
        </div>
      </div>
      <div class="dialog-bottom">
        <button type="submit" class="btn btn-primary d-block w-100" [disabled]="form.invalid">
          {{ 'global.signin' | transloco }}
        </button>
      </div>
    </form>
  </div>
</div>
